import { DEFAULT_DATE_FORMAT } from 'module/types/common';
import moment from 'moment';
import { KeyCreatorFunction } from './types';

const durations = {
  Today: 'today',
  Tomorrow: 'tomorrow',
  Upcoming: 'upcoming',
  LastTwoWeeks: 'last_two_weeks',
  OlderProjects: 'older_projects',
  None: 'no_start_date',
};

export const defaultStartDateOrder = [
  durations.Today,
  durations.Tomorrow,
  durations.Upcoming,
  durations.LastTwoWeeks,
  durations.OlderProjects,
  durations.None,
];

function getLabel(diff) {
  switch (true) {
    case diff === 0:
      return durations.Today;
    case diff === 1:
      return durations.Tomorrow;
    case diff > 1:
      return durations.Upcoming;
    case diff >= -14 && diff < 0:
      return durations.LastTwoWeeks;
    case diff < -14:
      return durations.OlderProjects;
    default:
      return durations.None;
  }
}

export const startDateKeyCreator: KeyCreatorFunction = ({ value: date }) => {
  const diff = date
    ? moment(date).diff(moment().format(DEFAULT_DATE_FORMAT), 'days')
    : undefined;

  return getLabel(diff);
};
